import React from "react"
import FieldProto_FormElement from "../../../../proto/render/form-element";
import FieldProject from "../project";
import {SelectParent_RenderType} from "../../../../../gd-ui/select-parent-new/@const";
import SelectParentNew from "../../../../../gd-ui/select-parent-new/select-parent-new";

export default class FieldProject_FormElement extends FieldProto_FormElement {

    render() {
        const field: FieldProject = this.props.field as FieldProject

        return <SelectParentNew className      = {this.props.className}
                                projectId      = {this.value}
                                parentsFor     = {field.parentsFor}
                                placeholder    = {field.placeholder}
                                renderType     = {SelectParent_RenderType.FORM}
                                disabled       = {this.props.disabled}
                                onChange       = {this.onChange}/>
    }
}
